<template>
  <Loader v-if="loading && editMode"></Loader>
  <div v-else>
    <Breadcrumb :items="items" />
    <noData v-if="noData" />
    <!-- ==== Start Form ==== -->
    <form @submit.prevent="validateCreateForm">
      <div class="container">
        <div class="row justify-content-between">
          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <label class="form-label">
                {{ $t("forms.labels.permission_label") }}
              </label>
              <multiselect
                v-model="data.permission_label_id"
                :options="permission_labels"
                label="name"
                track-by="id"
                placeholder=" "
                :searchable="true"
                :allow-empty="true"
                :show-labels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <label class="form-label">
                {{ $t("forms.labels.type") }}
              </label>
              <multiselect
                v-model="data.permission_type"
                :options="permission_types"
                label="name"
                track-by="id"
                placeholder=" "
                :searchable="true"
                :allow-empty="true"
                :show-labels="false"
              ></multiselect>
            </div>
          </div>

          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <input
                @keypress="isArabic"
                type="text"
                class="form-control"
                @input="helper_checkIfInputIsEmpty"
                v-model.trim="data.ar.name"
              />
              <label for="name_input" class="form-label">
                {{ $t("forms.labels.title_ar") }}
              </label>
            </div>
          </div>
          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <input
                @keypress="isEnglish"
                type="text"
                class="form-control"
                @input="helper_checkIfInputIsEmpty"
                v-model.trim="data.en.name"
              />
              <label for="name_input" class="form-label">
                {{ $t("forms.labels.title_en") }}
              </label>
            </div>
          </div>

          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <input
                type="text"
                class="form-control"
                @input="helper_checkIfInputIsEmpty"
                v-model.trim="data.icon"
              />
              <label for="name_input" class="form-label">
                {{ $t("forms.labels.icon") }}
              </label>
            </div>
          </div>

          <!-- <div class="col-12 py-0">
              <div class="input_wrapper top_label">
                <label for="textarea_1" class="form-label">
                  {{ $t("forms.labels.priority") }}
                </label>
                <input
                  type="number"
                  class="form-control"
                  rows="5"
                  v-model="data.priority"
                />
              </div>
            </div> -->
        </div>
      </div>

      <div class="buttons_wrapper">
        <button class="button_style_1" :disabled="btnIsLoading">
          {{ $t("forms.submit") }}
          <span class="btn_loader" v-if="btnIsLoading"></span>
        </button>
      </div>
    </form>
    <!-- ==== End Form ==== -->
  </div>
</template>

<script>
export default {
  name: "Create",
  props: ["id"],
  data() {
    return {
      noData: false,
      loading: false,
      btnIsLoading: false,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.permission-categories.title"),
          disabled: false,
          href: "/permission-categories/show-all",
        },
        {
          text: this.$t("breadcrumb.permission-categories.add"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading

      // ========== create_data
      data: {
        ar: {
          name: null,
        },
        en: {
          name: null,
        },
        icon: null,

        permission_label_id: null,
        permission_type: null,
      },
      permission_labels: [],
      permission_types: [
        {
          id: "general",
          name: "عامة",
        },
        {
          id: "with_category",
          name: "تحتوي علي أقسام",
        },
      ],
    };
  },
  computed: {
    editMode() {
      return !!this.id;
    },
  },

  methods: {
    resetForm() {
      this.data.ar.name = null;
      this.data.en.name = null;
      this.data.icon = null;
      this.data.permission_type = null;
      this.data.permission_label_id = null;
    },
    //validate Form
    validateCreateForm() {
      if (!this.data.permission_label_id) {
        this.$iziToast.error({
          timeout: 2000,
          message: "القسم الرئيسي للصلاحية مطلوب",
          position: "bottomRight",
        });
      } else if (!this.data.permission_type) {
        this.$iziToast.error({
          timeout: 2000,
          message: "النوع مطلوب",
          position: "bottomRight",
        });
      } else if (!this.data.ar.name) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.title_ar"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.en.name) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.title_en"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        this.submitData();
      }
    },
    submitData() {
      this.btnIsLoading = true;
      const frmData = new FormData();
      frmData.append("ar[name]", this.data.ar.name);
      frmData.append("en[name]", this.data.en.name);

      frmData.append("icon", this.data.icon ?? "");
      frmData.append("permission_label_id", this.data.permission_label_id.id);

      frmData.append("key", this.data.permission_type.id);

      if (this.id) {
        frmData.append("_method", "PUT");
      }
      let url = "";

      if (this.id) {
        url = `permission_category/${this.id}`;
      } else {
        url = "permission_category";
      }

      let message = this.id ? this.$t("editSuccess") : this.$t("addSuccess");

      this.$axios
        .post(url, frmData)
        .then(() => {
          this.$iziToast.success({
            title: this.$t("success"),
            message: message,
          });
          this.$router.push("/permission-categories/show-all");
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.btnIsLoading = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message ?? err.response.data.messages,
            position: "bottomRight",
          });
        });
    },
    getEditData() {
      this.noData = false;
      if (this.editMode) {
        this.loading = true;
        this.$axios({
          method: "GET",
          url: `permission_category/${this.id}`,
        })
          .then((res) => {
            this.loading = false;
            const result = res.data.data;

            this.data = {
              ar: result.ar,
              en: result.en,
              permission_type: this.permission_types.find(
                (el) => el.id == result.key
              ),
              icon: result.icon,
              permission_label_id: {
                id: result.permission_label.id,
                name: result.permission_label[this.$i18n.locale].name,
              },
            };
          })
          .catch((err) => {
            this.$iziToast.error({
              title: this.$t("error"),
              message:
                err.response?.data.message ?? err.response?.data.messages,
            });
            this.noData = true;

            this.loading = false;
          });
      }
    },
    getCategoryLabels() {
      this.$axios.get("permission_label_not_paginated").then(
        (res) =>
          (this.permission_labels = res.data.data.map((el) => ({
            id: el.id,
            name: el[this.$i18n.locale].name,
          })))
      );
    },
  },

  created() {
    this.control = this.$permission.setControls(this.$route.path);
    if (this.id) {
      this.getEditData();
    }
    this.getCategoryLabels();
  },
};
</script>
<style lang="scss">
.permissions_row {
  border: 1px solid var(--main);
  border-radius: 10px;
  padding: 10px;
}
</style>
